var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("개인정보처리방침")]),_c('div',{staticClass:"corner"},[_c('h2',[_vm._v("개인정보의 처리")]),_c('div',{staticClass:"content"},[_vm._v(" '[TL] 앱 자동실행' 은 개인정보를 수집/동의하지 않습니다 ")])])])
}]

export { render, staticRenderFns }